import { render, staticRenderFns } from "./AlertMessage.vue?vue&type=template&id=83b6f0b8"
import script from "./AlertMessage.vue?vue&type=script&lang=ts"
export * from "./AlertMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports